import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import AlertsGroupList from "./AlertsGroupList";
import { Box } from "@mui/material";
import { fetchRequest, setActionType, setCurrentModal, clearFilter } from "../../../store/actions/alertsGroup";
import CustomModal from "../../../components/CustomModal";
import AlertGroupDetails from "./CreateAlertGroup/AlertGroupDetail";
import { Button } from "@vds/buttons";
import Grid2 from "@mui/material/Unstable_Grid2/Grid2";
import { setAlertGroupDetail } from "../../../store/actions/alertsGroup";
import styles from '../../../styles/alertsGroup.module.css';

const AlertsGroup = () => {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.auth.user);
  const filters = useSelector((state) => state.alertsGroup.filters);
  console.log("Filters in AlertsGroup:", filters);
  useEffect(() => {
    dispatch(
      fetchRequest({...filters})
    );
    dispatch(
      clearFilter()
    )
  }, [dispatch,user?.accountId]);

  // const handleClick = (val) => {
  //   dispatch(fetchRequest({ ...filters, level: val }));
  // };

  return (
    <Box
      sx={{
        minHeight: "65vh",
        margin: "0 auto",
        display: "flex",
        flexDirection: "column",
        width: "100%",
      }}
    >
      <Box style={{ position: 'absolute', top: '8.2%', right: '3vw' }}>
        <Grid2 item xs={12} sm={6} md={6} lg={6}>
          <div className="mb-3">
            <Button
              shape="round"
              className={`${styles.buttonSpan} custom-button-cancel`}
              style={{
                width: "100%",
                backgroundColor: "black",
                color: "white",
              }}
              onClick={()=>{dispatch(setAlertGroupDetail({alertGroupName: '', description: '', userList: []}));dispatch(setActionType('Add'));dispatch(setCurrentModal('AlertGroupDetailModal'))}}
              size={"large"} use="primary" >
              {'Add Alert Group'}
            </Button>
          </div>
        </Grid2>
      </Box>

      <Box
        sx={{
          "& .tab-content": {
            width: "100%",
          },
        }}
        className="tab-content"
        id="myTabContent"
      >
        <AlertsGroupList />
      </Box>
    </Box>
  );
};

export default AlertsGroup;
